import React from 'react';
import Lv2Nav from './Lv2Nav';
import Footer from './Footer';
import '../landing-v2/landing-v2-fonts';
import '../../styles/odd-global.css';
import './lv2-nav.css';
import './SiteLayout.css';

const SiteLayout = ({ children }) => (
  <div className="odd-page site-layout">
    <Lv2Nav />
    <div className="site-layout-main">{children}</div>
    <Footer />
  </div>
);

export default SiteLayout;
